(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vurevu-approved"] && !Shopify.designMode) return;
  try {
    
function initVurevuApproved() {
 const root = document.getElementById('vurevu-approved');
 if (!root || root.dataset.ready) return;
 root.dataset.ready = 'true';
 root.querySelectorAll('[data-photo]').forEach(button => {
  button.addEventListener('click', () => {
   const image = button.querySelector('img');
   const main = root.querySelector('#vv-main-image');
   main.src = image.src;
   main.alt = image.alt;
   root.querySelectorAll('[data-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
 });
 const form = root.querySelector('#vv-product-form');
 if (form) {
  const submit = form.querySelector('#vv-submit');
  const feedback = form.querySelector('[data-mitt-feedback]');
  form.addEventListener('submit', async event => {
   event.preventDefault();
   if (submit.disabled || !form.reportValidity()) return;
   submit.disabled = true; submit.textContent = root.dataset.adding; feedback.textContent = '';
   try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
    if (!response.ok) { await response.json(); throw new Error(root.dataset.error); }
    feedback.textContent = root.dataset.added;
    form.querySelector('[data-mitt-cart]').hidden = false;
    try {
     const result = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
     if (result.ok) { const cart = await result.json(); root.querySelector('#vv-count').textContent = cart.item_count; }
    } catch (error) {}
   } catch (error) { feedback.textContent = root.dataset.error; }
   finally { submit.disabled = false; submit.textContent = submit.dataset.ready; }
  });
 }
 const quantity = root.querySelector('#vv-mitt-quantity');
 const packOptions = root.querySelectorAll('input[name="pack_choice"]');
 if (quantity) {
  function syncQuantity() {
   const count = Number(quantity.value);
   if (!Number.isSafeInteger(count) || count < 1) return;
   packOptions.forEach(input => { input.checked = Number(input.value) === count; });
   const unit = Number(root.dataset.unitCents);
   const total = count * unit - Math.floor(count / 2) * 799;
   root.querySelector('[data-mitt-total]').textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(total / 100);
   root.querySelector('#vv-price').textContent = root.dataset.priceOne;
   root.querySelector('#vv-saving').hidden = true;
  }
  quantity.addEventListener('input', syncQuantity);
  quantity.addEventListener('change', syncQuantity);
  packOptions.forEach(input => input.addEventListener('change', () => {
   quantity.value = input.value;
   syncQuantity();
  }));
  syncQuantity();
 }
 root.querySelectorAll('.vv-video-play, .vv-watch').forEach(button => {
  button.addEventListener('click', () => {
   const poster = root.querySelector('.vv-video-poster');
   if (poster.querySelector('iframe')) return;
   const id = root.dataset.videoId;
   if (!/^\d+$/.test(id)) return;
   const frame = document.createElement('iframe');
   frame.src = 'https://www.tiktok.com/player/v1/' + id + '?autoplay=0';
   frame.title = root.dataset.videoTitle;
   frame.allow = 'fullscreen; encrypted-media';
   frame.allowFullscreen = true;
   poster.replaceChildren(frame);
   root.querySelector('.vv-video-notice').hidden = false;
  });
 });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVurevuApproved);
else initVurevuApproved();
document.addEventListener('shopify:section:load', initVurevuApproved);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vurevu-mitts"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('#vurevu-preview-video').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>{const img=root.querySelector('.mainimage img');img.src=button.querySelector('img').src;img.alt=button.getAttribute('aria-label');root.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vurevu-soap"] && !Shopify.designMode) return;
  try {
    

function initSoapV2(){
document.querySelectorAll('[data-soap-v2]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const form=root.querySelector('#soap-form'),button=root.querySelector('[data-submit]'),main=root.querySelector('#soap-main-image'),feedback=root.querySelector('[data-feedback]');
function readyLabel(){
const selected=form.querySelector('input[name=id]:checked');
const quantity=Number(form.querySelector('[name=quantity]').value);
if(!selected||!Number.isInteger(quantity)||quantity<1)return button.dataset.ready;
const total=new Intl.NumberFormat('en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(Number(selected.dataset.amount)*quantity/100);
return button.dataset.ready+' — '+total;
}
form.querySelector('[name=quantity]').addEventListener('input',()=>{if(!button.disabled)button.textContent=readyLabel();});
if(!button.disabled)button.textContent=readyLabel();
function photo(src,alt){if(!src||!main)return;main.removeAttribute('srcset');main.src=src;if(alt)main.alt=alt;}
root.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{photo(b.dataset.image,b.dataset.alt);root.querySelectorAll('[data-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));}));
form.querySelectorAll('input[name=id]').forEach(radio=>radio.addEventListener('change',()=>{
root.querySelector('[data-price]').textContent=radio.dataset.price;button.disabled=radio.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:readyLabel();feedback.textContent='';root.querySelector('[data-cart-link]').hidden=true;photo(radio.dataset.variantImage);
const url=new URL(location.href);url.searchParams.set('variant',radio.value);history.replaceState({},'',url);
}));
form.addEventListener('submit',async event=>{
event.preventDefault();if(button.disabled||!form.reportValidity())return;
button.disabled=true;button.textContent=root.dataset.adding;feedback.textContent='';
try{
const result=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
const data=await result.json();if(!result.ok)throw new Error(root.dataset.error);
feedback.textContent=root.dataset.added;root.querySelector('[data-cart-link]').hidden=false;
try{const c=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');if(c.ok){const cart=await c.json();root.querySelector('[data-count]').textContent=cart.item_count;}}catch(e){}
}catch(e){feedback.textContent=root.dataset.error;}
finally{const selected=form.querySelector('input[name=id]:checked');button.disabled=selected.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:readyLabel();}
});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSoapV2);else initSoapV2();
document.addEventListener('shopify:section:load',initSoapV2);


  } catch(e) { console.error(e); }
})();
})();
